// Centralised front-end access rules. Keep these in lock-step with the
// backend guards (see backend/auth.py and backend/rbac.py) so the UI never
// shows an action the API will reject.

const MANAGEMENT_ROLES = ['org_admin', 'admin', 'global_admin'];

export function isManagement(user) {
  return MANAGEMENT_ROLES.includes(user?.role);
}

// Smart locks are a management feature. Front-desk (reception) staff also
// need them to issue / resend guest PINs, so they are allowed in too.
// Housekeeping and other departments are not.
export function canAccessSmartLocks(user) {
  if (isManagement(user)) return true;
  return user?.role === 'employee'
    && (user?.department || '').trim().toLowerCase() === 'reception';
}
